(() => {
  function initFaqPage(root = document) {
    root.querySelectorAll('[data-bvm-faq-page]').forEach((page) => {
      if (page.dataset.bvmReady === 'true') return;
      page.dataset.bvmReady = 'true';

      const items = Array.from(page.querySelectorAll('[data-bvm-faq-item]'));
      let syncing = false;

      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (syncing || !item.open) return;

          syncing = true;
          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
          syncing = false;
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initFaqPage());
  } else {
    initFaqPage();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFaqPage(event.target);
  });
})();
